import { render, staticRenderFns } from "./NavbarSimple.vue?vue&type=template&id=804fdf32&"
import script from "./NavbarSimple.vue?vue&type=script&lang=js&"
export * from "./NavbarSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports